/* eslint-disable no-console */
import { useEffect, useState } from 'react';

import CustomLoader from '../common/loader';
import apiBackendInstance from '../../utils/axios';
import Urls from '../../utils/urls';
import { prefixPath } from '../../utils/helpers';

interface protocolList {
    name: string;
    types: string[];
}
const SupportedProtocols = () => {
  const [protocolData, setProtocolData] = useState([] as protocolList[]);
  const [dataLoading, setDataLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  const getProtocolDetails = () => {
    setShowLoader(true);
    apiBackendInstance.get(Urls.getSupportedProtocols(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data) {
        setDataLoading(false);
        setProtocolData(response.data.data);
      }
      setShowLoader(false);
    })
      .catch((err) => {
        setShowLoader(false);
        setDataLoading(false);
        setProtocolData([]);
        console.error(err);
      });
  };

  useEffect(() => {
    getProtocolDetails();
  }, []);

  const setImage = (val: string) => {
    if (!val) {
      return '';
    }
    if (val.includes(' ')) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      val = val.split(' ')[1];
    }
    switch (val.toLowerCase()) {
      case 'corda': return '../images/protocols/logos/corda_logo.svg';
      case 'ethereum': return '../images/protocols/logos/ethereum_logo.svg';
      case 'credit': return '../images/protocols/logos/credits.png';
      case 'fabric': return '../images/protocols/logos/Hyperledger-Fabric_logo.svg';
      case 'sawtooth': return '../images/protocols/logos/sawtooth_logo.svg';
      case 'fluree': return '../images/protocols/logos/fluree_logo.svg';
      case 'phaeton': return '../images/protocols/logos/phaeton_logo.svg';
      case 'polygon': return '../images/protocols/logos/Polygonpos_logo.svg';
      case 'binance': return '../images/protocols/logos/binance_logo.svg';
      case 'tron': return '../images/protocols/logos/tron_logo.svg';
      case 'avalanche': return '../images/protocols/logos/avalanche_logo.svg';
      case 'axia': return '../images/protocols/logos/axia_logo.svg';
      case 'fantom': return '../images/protocols/logos/Fantom_logo.svg';
      case 'dcomm': return '../images/protocols/logos/dcommdark_logo.svg';
      case 'polkadot': return '../images/protocols/logos/Polkadot_logo.svg';
      case 'okc': return '../images/protocols/logos/okc_logo.svg';
      case 'aptos': return '../images/protocols/logos/Aptos_logo.svg';
      case 'coreum': return '../images/protocols/logos/Coreum_logo.svg';
      case 'shardeum': return '../images/protocols/logos/Shardeum_logo.svg';
      case 'energy-web': return '../images/protocols/logos/Energy_Web_Logo.svg';
      case 'enterprise': return '../images/protocols/logos/corda_logo.svg';
      case 'blockchain': return '../images/protocols/logos/provenance_blockchain_logo.svg';
      case 'zksyncera': return '../images/protocols/logos/zksyncera_logo.svg';
      case 'avalanche-subnets': return '../images/protocols/logos/avalanche_logo.svg';
      case 'bahamut': return '../images/protocols/logos/fastex_logo.svg';
      case 'opstack': return '../images/protocols/logos/opstack_logo.svg';
      case 'orbit': return '../images/protocols/logos/arbitrum_orbit_logo.svg';
      case 'shido': return '../images/protocols/logos/shido_logo.svg';
      case 'subsquid': return '../images/protocols/logos/subsquid-logo-dark.svg';

      default: return '';
    }
  };
  const imgSubPath = window.location.origin;
  const spinner = imgSubPath + prefixPath('/img/zeeve/spin.svg');
  return (
        <div>
          <CustomLoader showLoader={showLoader} />
            <div className="row g-5 mt-1 mb-3 px-3">
            {dataLoading && (
                    <div className="text-center">
                    <img src={spinner} alt="" />
                    </div>
            )}
                {(!dataLoading && (!protocolData || protocolData.length === 0)) && (
                    <div>
                    <h5 className="text-muted text-center">No Data</h5>
                    </div>
                )}
                {
                    [...protocolData].map((data, idx) => (
                        <div className="col-md-6 col-sm-12 " key={`${data.name}-${idx.toString()}`}>
                            <div className="card-susbscription h-100 p-3 shadow-sm user-select-none">
                                <div className="text-center">
                                    <div className="">
                                    <img className="ps-2" src={setImage(data.name)} alt="" height={42} />
                                    </div>
                                </div>
                                <div className="mt-4 text-center">
                                    {
                                        data.types.map((type) => (
                                          idx % 2 ? <span className="badge rounded-pill mx-2 bg-primary" key={`${data.name}-${type}`}>{type}</span>
                                            : <span className="badge  rounded-pill mx-2 bg-secondary" key={`${data.name}-${type}`}>{type}</span>

                                        ))
                                    }
                                </div>
                            </div>

                        </div>
                    ))
                }

            </div>

        </div>
  );
};
export default SupportedProtocols;